const canonical = href => href.replace(/[#?]+.*$/, '');
export default canonical;